import { all } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";

//Database
import DatabaseSaga from "./database/saga";

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    AuthSaga(),
    ForgetSaga(),
    ProfileSaga(),
    LayoutSaga(),
    DatabaseSaga(),
    // Access_Saga(),
    // Builder_Saga(),
    // QR_Code_Saga(),
    // Results_And_Attendance_Saga(),
  ]);
}
